import moment from 'moment-timezone'
import store from '@/core/store'
import {mutationTypes} from '@/core/constants'

class SetFusoHorarioListener {
    async execute() {
        return new Promise((resolve) => {
            store.commit(mutationTypes.LOKI.SET_TIMEZONE, store.state.parametros.propriedadesCompraDiretas.timezoneFusoHorario)
            moment.tz.setDefault(store.state.parametros.propriedadesCompraDiretas.timezoneFusoHorario)
            moment.locale('pt')
            resolve()
        })
    }
}

export default new SetFusoHorarioListener()
